/**
 * Поле формы ввода адресов пользователя.
 */
export enum Field {
  REGISTRATION = 'registration',
  LIVING = 'residence',
  IS_SAME = 'isSameAddress',
}
